var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content kef-docking" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("SystemDocking.BatchImportOrders"),
                  name: "tabBatchImportOrder",
                  lazy: true
                }
              },
              [_c("tab-batch-import-order")],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("SystemDocking.BatchExportOrders"),
                  name: "tabBatchExportOrder",
                  lazy: true
                }
              },
              [_c("tab-batch-export-order")],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("SystemDocking.BatchExportBills"),
                  name: "tabBatchExportBill",
                  lazy: true
                }
              },
              [_c("tab-batch-export-bill")],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }